export enum FeedSubType {
  FUNCTIONAL = 'functional',
  REGULAR = 'regular',
}
